/**
 * The one rule for a name's initials, shared by `Avatar` and the app: the
 * first letter of the first word and of the last word. Empty when there is
 * nothing to abbreviate — each caller picks its own placeholder.
 */
export function toInitials(name?: null | string) {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '';
  const first = words[0].charAt(0);
  const last = words.length > 1 ? words[words.length - 1].charAt(0) : '';
  return (first + last).toUpperCase();
}
